import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import 'sass/list/MemberPhotoList.scss';
import {openMemberPhoto} from 'reducers/memberPhoto';

class MemberPhotoList extends Component {
    render() {
        let {memberPhotos, openMemberPhoto, editFn, singleRow = false, doubleRow = false} = this.props;
        let viewFn = openMemberPhoto;

        let editFnWrapper;
        if (editFn) {
            editFnWrapper = function(event, memberPhoto) {
                event.stopPropagation();
                editFn(memberPhoto);
            };
        }

        return (
            <div className={'member-photo-list ui-responsive-grid ' + (singleRow ? 'single-row' : '') + (doubleRow ? 'double-row' : '')}>
                {memberPhotos.map((memberPhoto, index, memberPhotos) =>
                    <div key={index}>
                        <div
                            className={'member-photo-list-item' + (viewFn ? ' viewable' : '')}
                            onClick={viewFn ? () => {viewFn(memberPhoto, memberPhotos)} : null}
                        >
                            {editFnWrapper && <div className="icon-edit" onClick={(event) => editFnWrapper(event, memberPhoto)}/>}
                            <img src={memberPhoto.thumb_url} alt=""/>
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

MemberPhotoList.propTypes = {
    memberPhotos: PropTypes.array.isRequired,
    openMemberPhoto: PropTypes.func,
    editFn: PropTypes.func,
    singleRow: PropTypes.bool
};

export default connect(
    (state) => ({
        currentUser: state.currentUser
    }),
    {
        openMemberPhoto: openMemberPhoto
    }
)
(MemberPhotoList);


// WEBPACK FOOTER //
// ./src/components/list/MemberPhotoList.js